import RibbonButton from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { clearFormat } from 'roosterjs-editor-api';

const removeFormat: RibbonButton = {
    key: 'removeFormat',
    title: () => strings.removeFormat,
    imageSrc: require('../svg/removeformat.svg'),
    onExecute: plugin => clearFormat(plugin.getEditor()),
};

export default removeFormat;
